import React from 'react'

import EnumDropdown, { getValueFunc } from '../../../../organisms/enum-dropdown/EnumDropdown'

interface Props {
  onChange: (selected: { value: string, label: string}) => void
  value?: string
  error?: string
  label?: string
  name?: string
}

export const options = [
  {
    value: 'vanilla_3_rounds',
    label: 'Vanilla - 3 Rounds'
  },
  {
    value: 'vanilla_4_rounds',
    label: 'Vanilla - 4 Rounds'
  },
  {
    value: 'vanilla_5_rounds',
    label: 'Vanilla - 5 Rounds'
  },
  {
    value: 'risk_virtual_workshop',
    label: 'Risk Virtual Workshop'
  },
  {
    value: '2022_4_rounds',
    label: '2022 - 4 Rounds'
  }
]

export const getLabelFromValue = getValueFunc(options)

function EconomyDropdown({
  onChange,
  value,
  error,
  label,
  name,
}: Props) {
  return (
    <EnumDropdown
      onChange={onChange}
      options={options}
      value={value}
      error={error}
      label={label}
      name={name ?? 'economy-dropdown'}
    />
  )
}


export default EconomyDropdown
